import { QueryClientProvider } from "@tanstack/react-query";
import { LazyMotion } from "motion/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ToastViewport } from "./components/feedback";
import { AuthProvider } from "./contexts/AuthContext";
import { queryClient } from "./lib/query-client";
import "./styles/index.css";
// 머티리얼·누름 피드백은 **유틸리티 클래스** 레이어라, Tailwind 유틸리티보다
// 뒤에 실려야 같은 명시도 싸움에서 이겨요. `index.css` 안에서 `@import` 로 두면
// Vite 가 @import 를 파일 맨 위로 끌어올려서 그 순서가 조용히 뒤집힙니다.
import "./styles/apple/materials.css";
// 개념 레이어(`DESIGN.md`)도 같은 이유로 유틸리티 뒤에, 머티리얼 다음에 실어요.
import "./styles/tranche.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root 엘리먼트를 찾을 수 없어요.");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          {/*
            모션 기능은 첫 페인트 뒤에 받아요(`lib/motion-features.ts`). `strict` 는
            `<motion.div>` 를 실수로 쓰면 던지게 합니다 — 그걸 쓰는 순간 이
            게으른 로딩이 무의미해지고 기능 전체가 최초 청크로 돌아와요.
          */}
          <LazyMotion
            strict
            features={() => import("@/lib/motion-features").then((mod) => mod.default)}
          >
            <App />
            <ToastViewport />
          </LazyMotion>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
